import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { departmentSchema } from "./schema";
import { fetchDepartmentData } from "./read";
import { useUpdateDepartment } from "../update/mutation";
import { useCreateDepartment } from "../create/mutation";

export const useDepartmentForm = ({ departmentId }) => {
  const form = useForm({
    resolver: zodResolver(departmentSchema),
    defaultValues: {
      name: "",
      head: "",
      coordinators: [],
    },
  });

  const updateDepartment = useUpdateDepartment();
  const createDepartment = useCreateDepartment();

  const handleCreate = async (context) => {
    const item = context.values;
    await createDepartment.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateDepartment.mutateAsync({ departmentId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchDepartmentData({ departmentId: id });
    return {
      ...response,
      coordinators: response.coordinators?.map(coord => coord.coordinator) || [],
    };
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
